import { useState, useEffect, useContext } from "react";
import Repo from "../../Utility/Repo";
import React from "react";
import { Input } from "design-react-kit";

import iconSprite from "bootstrap-italia/dist/svg/sprite.svg";
import ModalComponent from "../../Components/ModalComponent";
import ResponsabileModal from "./ResponsabiliModal";
import Spinner from "../../Components/Loader";

function ResponsabiliMenuOp(props) {
  const [isOpenUpdate, toggleModalUp] = useState(false);
  const [responsabiles, setResponsabiles] = useState();
  const [showModalDel, setShowModalDel] = useState(false);
  const [localResponsabileId, setLocalResponsabileId] = useState();
  const [listaScuole, setListaScuole] = useState();
  const [responsabileCf, setResponsabileCf] = useState();
  const [responsabileListaScuole, setResponsabileListaScuole] = useState([]);

  const [responsabilesFiltered, setResponsabilesFiltered] = useState([{}]);
  const [loading, setLoading] = useState(false);
  const [filter, setFilter] = useState({
    codiceFiscale: "",
    udoList: "",
    id: "",
  });

  useEffect(() => {
    setLoading(true);
    Repo.getListaScuoleOperatori(props.apiToken)
      .then((response) => {
        if (response.status == 200) {
          setResponsabiles(response.data);
          setLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });

    Repo.getListaScuole(props.apiToken)
      .then((response) => {
        if (response.status == 200) {
          setListaScuole(response.data);
          setLoading(false);
        }
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  }, []);

  useEffect(() => {
    var newArray = [];

    if (responsabiles !== undefined) {
      newArray = responsabiles?.filter((responsabile) => {
        return (
          responsabile?.codiceFiscale
            ?.toLowerCase()
            .includes(filter?.codiceFiscale?.toLowerCase()) &&
          responsabile?.udoList
            ?.toLowerCase()
            .includes(filter?.udoList?.toLowerCase()) &&
          responsabile?.id?.toLowerCase().includes(filter?.id?.toLowerCase())
        );
      });
      setResponsabilesFiltered(newArray);
    }
  }, [filter, responsabiles]);

  const handleDeleteResponsabile = () => {
    setLoading(true);
    Repo.delResponsabileScuola(props.apiToken, localResponsabileId)
      .then((response) => {
        window.location.reload();
      })
      .catch((error) => {
        console.log(error);
        setLoading(false);
      });
  };

  const postUpdateResponsabile = () => {
    const UDOList = responsabileListaScuole.map((scuola) => scuola).join("/;/");

    const data = {
      uDOList: UDOList,
      codiceFiscale: responsabileCf,
    };

    Repo.postOrUpdateScuolaOperatori(props.apiToken, data)
      .then((response) => {
        if (response.status == 200) {
          window.location.reload();
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  return (
    <>
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-12">
            <h1 className="text-black hero-title">Lista responsabili</h1>
            <p className="text-black">
              Tutte i profili responsabili presenti. Da qui è possibile gestire
              i profili responsabili.
            </p>
          </div>
        </div>
        <div className="row mt-3">
          <div className="col-12 d-flex justify-content-end">
            <button
              className="btn btn-outline-primary px-3 ml-1 text-right"
              type="button"
              data-toggle="tooltip"
              data-placement="top"
              onClick={() => (
                toggleModalUp(true),
                setResponsabileCf(""),
                setResponsabileListaScuole([])
              )}
            >
              Aggiungi responsabile
              <svg className="icon icon-primary">
                <use href={`${iconSprite}#it-plus`} />
              </svg>
            </button>
          </div>
          {responsabilesFiltered?.length > 0 ||
          Object.values(filter).every(
            (value) => value === null || value === ""
          ) === false ? (
            <>
              <div className="mt-4 w-100 cerca">
                <div className="row mt-1">
                  <div className="col-3">
                    <div className="input-group">
                      <Input
                        id="codiceFiscale"
                        label="Ricerca per Codice Fiscale"
                        className="flex-grow-1"
                        type="text"
                        onChange={(e) =>
                          setFilter({
                            ...filter,
                            [e.target.id]: e.target.value,
                          })
                        }
                      />
                    </div>
                  </div>
                  <div className="col-3 offset-1">
                    <div className="input-group">
                      <Input
                        id="udoList"
                        label="Ricerca per Scuola"
                        className="flex-grow-1"
                        type="text"
                        onChange={(e) =>
                          setFilter({
                            ...filter,
                            [e.target.id]: e.target.value,
                          })
                        }
                      />
                    </div>
                  </div>
                  <div className="col-3 offset-1">
                    <div className="input-group">
                      <Input
                        id="id"
                        label="Ricerca per Id Responsabile"
                        className="flex-grow-1"
                        type="text"
                        onChange={(e) =>
                          setFilter({
                            ...filter,
                            [e.target.id]: e.target.value,
                          })
                        }
                      />
                    </div>
                  </div>
                </div>
              </div>
              <p className="">
                <strong className="mx-2">
                  {responsabilesFiltered?.length}
                </strong>
                responsabili trovati in ordine cronologico
              </p>
              {responsabilesFiltered.map((responsabile, index) => (
                <div
                  className="col-lg-12 d-flex align-items-stretch "
                  key={responsabile.id + index}
                >
                  <div className="card card-teaser shadow mb-4">
                    <div className="card-body">
                      <div className="row mb-1">
                        <div className="col-9">
                          Id Responsabile: <strong>{responsabile.id}</strong>
                        </div>
                      </div>
                      <div className="row mt-3">
                        <div
                          className="col-lg-5"
                          style={{ borderRight: "inset" }}
                        >
                          <div className="col-lg-12">
                            <h5 className="card-title mb-2">
                              Dati Responsabile
                            </h5>
                          </div>
                          <div className="card-text">
                            <div className="row mt-1 pl-1">
                              <div className="col-5">Codice Fiscale</div>
                              <div className="col-7">
                                <b>{responsabile.codiceFiscale}</b>
                              </div>
                            </div>
                          </div>
                        </div>
                        <div className="col-lg-6">
                          <div className="row">
                            <div className="col-10">
                              <h5 className="card-title mb-2">
                                Scuole Abilitate
                              </h5>
                            </div>
                            <div className="col-1"></div>
                            <div className="col-1"></div>
                          </div>
                          <div className="it-list-wrapper">
                            <ul className="it-list">
                              {responsabile.udoList?.split("/;/")?.length >
                              0 ? (
                                responsabile.udoList
                                  .split("/;/")
                                  .map((scuola) => (
                                    <li key={scuola} className="pl-1">
                                      {scuola}
                                    </li>
                                  ))
                              ) : (
                                <li className="text-warning">
                                  Nessun Appuntamento Luogo Abilitato
                                </li>
                              )}
                            </ul>
                          </div>
                        </div>
                        <div className="col-lg-1 ">
                          <div className="row">
                            <div className="col-5">
                              <button
                                className="btn btn-xs btn-outline-primary "
                                type="button"
                                data-toggle="tooltip"
                                data-placement="top"
                                onClick={() => {
                                  toggleModalUp(true);
                                  setResponsabileCf(responsabile.codiceFiscale);
                                  setResponsabileListaScuole(
                                    (responsabile.udoList || "")
                                      .split("/;/")
                                      .filter(Boolean)
                                  );
                                }}
                              >
                                <svg className="icon icon-primary">
                                  <use href={`${iconSprite}#it-pencil`} />
                                </svg>
                              </button>
                            </div>
                            <div className="col-6 offset-1">
                              <button
                                className="btn btn-xs btn-outline-danger"
                                type="button"
                                data-toggle="tooltip"
                                data-placement="top"
                                onClick={() => (
                                  setShowModalDel(true),
                                  setLocalResponsabileId(responsabile.id)
                                )}
                              >
                                <svg className="icon icon-danger">
                                  <use href={`${iconSprite}#it-delete`} />
                                </svg>
                              </button>
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              ))}
            </>
          ) : (
            <div
              className="alert alert-warning bg-white my-5 w-100"
              role="alert"
            >
              Nessun <b>Responsabile</b> presente.
            </div>
          )}
        </div>
      </div>
      <ModalComponent
        toggleModal={toggleModalUp}
        isOpen={isOpenUpdate}
        header="Aggiungi o modifica responsabile"
        body={
          <ResponsabileModal
            responsabileListaScuole={responsabileListaScuole}
            setResponsabileListaScuole={setResponsabileListaScuole}
            responsabileCf={responsabileCf}
            setResponsabileCf={setResponsabileCf}
            listaScuole={listaScuole}
          ></ResponsabileModal>
        }
        buttonConfirm="Conferma"
        buttonDeny="Annulla"
        function={() => postUpdateResponsabile()}
        size="xl"
      ></ModalComponent>
      <ModalComponent
        toggleModal={setShowModalDel}
        isOpen={showModalDel}
        header={"Elimina responsabile"}
        body={
          <>
            Sei sicuro di voler eliminare il responsabile{" "}
            <b>
              {
                responsabiles?.filter(
                  (item) => item.id === localResponsabileId
                )[0]?.codiceFiscale
              }
            </b>
            ? Questa operazione è irreversibile.
          </>
        }
        buttonDeny="Chiudi"
        buttonConfirm="Conferma"
        function={() => handleDeleteResponsabile()}
      ></ModalComponent>
      {loading && <Spinner></Spinner>}
    </>
  );
}

export default ResponsabiliMenuOp;
